'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var iconConfig = [{
	name: 'iconClosed',
	inputType: 'icon',
	label: 'Choose icon when dropdown is closed',
	default: false
}, {
	name: 'iconClosedSize',
	inputType: 'text',
	label: 'Set size on above icon',
	default: '2em'
}, {
	name: 'iconClosedColor',
	inputType: 'color',
	label: 'Set color on above icon',
	default: '#808080'
}, {
	name: 'iconOpen',
	inputType: 'icon',
	label: 'Choose icon when dropdown is open',
	default: false
}, {
	name: 'iconOpenSize',
	inputType: 'text',
	label: 'Set size on above icon',
	default: '2em'
}, {
	name: 'iconOpenColor',
	inputType: 'color',
	label: 'Set color on above icon',
	default: '#808080'
}];

var imageConfig = [{
	name: 'imageClosed',
	inputType: 'media',
	label: 'Image when dropdown is closed',
	default: 'example.png'
}, {
	name: 'imageOpen',
	inputType: 'media',
	label: 'Image when dropdown is open',
	default: 'example.png'
}];

var textConfig = [{
	name: 'label',
	inputType: 'text',
	label: 'Button text',
	default: 'Click me'
}];

var conditionallyAddConfig = function conditionallyAddConfig(node, conditionStr, configArray) {
	return node && node.props.type === conditionStr ? configArray : [];
};

exports.default = function (node) {
	return {
		type: 'DROPDOWN',
		name: 'Dropdown',
		allowedSections: ['main', 'header', 'footer'],
		disallowedChildren: [],
		category: 'Dropdown',
		props: [{
			name: 'type',
			inputType: 'select',
			label: 'What should open the dropdown?',
			default: 'icon',
			values: [{
				label: 'Icon',
				value: 'icon'
			}, {
				label: 'Image',
				value: 'image'
			}, {
				label: 'Text',
				value: 'text'
			}]
		}].concat(_toConsumableArray(conditionallyAddConfig(node, 'icon', iconConfig)), _toConsumableArray(conditionallyAddConfig(node, 'image', imageConfig)), _toConsumableArray(conditionallyAddConfig(node, 'text', textConfig)), [{
			name: 'openOnHover',
			inputType: 'checkbox',
			label: 'Open on hover',
			default: false
		}]),
		hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
	};
};